var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDarkPdfIcon = function SvgDarkPdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#343434",
    strokeWidth: 1.36,
    d: "M1.137 18.836V2.586c0-.66.535-1.195 1.195-1.195H9.68c.317 0 .621.126.845.35l3.987 3.986c.224.224.35.528.35.845v12.264c0 .66-.535 1.195-1.195 1.195H2.332c-.66 0-1.195-.535-1.195-1.195Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#343434",
    strokeWidth: 1.36,
    d: "M15.542 7.21h-5.48a1.017 1.017 0 0 1-1.017-1.015L9.042.71"
  })));
};
export default SvgDarkPdfIcon;